import classNames from 'classnames';
import React from 'react';

import { Theme } from '@insights-gaming/theme';
import { Avatar } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { Riot } from '../../../types';
import { LoLHelper } from '../../../utils';

interface LeagueOfLegendsItemsOwnProps {
  className?: string;
  items: number[];
  itemAssets: Riot.League.Item[];
  gameVersion: string;
}

type LeagueOfLegendsItemsProps = LeagueOfLegendsItemsOwnProps;

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'grid',
    gap: theme.spacing(0.5),
  },
  item: {
    width: 16,
    height: 16,
    '&:nth-child(n + 4)': {
      gridRow: 2,
    },
    '&:nth-child(7)': {
      gridColumn: 4,
      gridRow: 1,
    },
  },
  noItem: {
    border: '1px dotted black',
  },
}), {name: 'LeagueOfLegendsItems'});

export function LeagueOfLegendsItems(props: LeagueOfLegendsItemsProps) {
  const classes = useStyles(props);
  const { className, items, itemAssets, gameVersion } = props;
  return (
    <div className={classNames(classes.root, className)}>
      {Object.values(items).map((item, i) => {
        const path = itemAssets.find(i => i.id === item)?.iconPath;
        const src = path ? LoLHelper.getIconAsset(path, gameVersion) : undefined;
        return src
          ? <Avatar key={[i, item].join(',')} className={classes.item} src={src} />
          : <div key={[i, item].join(',')} className={classNames(classes.noItem, classes.item)} />;
      })}
    </div>
  );
}
